import {ChangeDetectionStrategy, Component, signal, WritableSignal} from '@angular/core';
import {PromotionModel} from "../../../models/promotion.model";
import {OwlOptions} from "ngx-owl-carousel-o";
import {PromotionService} from "../../../services/promotion.service";
import {UserModel} from "../../../models/user.model";
import {Subscription} from "rxjs";
import {UserService} from "../../../services/user.service";

@Component({
  selector: 'app-promo-slide',
  templateUrl: './promo-slide.component.html',
  styleUrls: ['./promo-slide.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PromoSlideComponent {

  staticPromos: PromotionModel[] = [];

  isDragging: WritableSignal<boolean> = signal(false); //?possible fix of "listenerOneMouseMove is not a function” error


  // owl-carousel-version: TODO when toggling sidebar the slide does not change size
  customOptions: OwlOptions = {
    loop: true,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    dots: true,
    nav: false,
    autoplay: true,
    autoplayHoverPause: true,
    autoplayTimeout: 6000,
    autoplaySpeed: 1000,
    responsive: {
      0: {
        items: 1,
        dots: false,
        touchDrag: true
      },
      566: {
        items: 2
      },
      992: {
        items: 3
      }
    }
  }

  user!: UserModel | null;
  userSubs: Subscription;

  constructor(
    private promoService: PromotionService,
    private userService: UserService
  ) {
    this.staticPromos = this.promoService.staticPromotions;

    this.userSubs = this.userService.userObject.subscribe(userData => {
      this.user = userData;
    })

  }

  ngOnDestroy(){
    this.userSubs?.unsubscribe();
  }


}
